import { render, staticRenderFns } from "./CongelationCommande.vue?vue&type=template&id=f8d80584&"
import script from "./CongelationCommande.vue?vue&type=script&lang=js&"
export * from "./CongelationCommande.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports